import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🕐", key: "dontLiveForever" },
  { emoji: "👨‍👩‍👦", key: "theyreFamily" },
  { emoji: "😊", key: "makesHappy" },
  { emoji: "🪞", key: "captureTrueSelf" },
]

export default function PetsTimeSpentPage() {
  return <RadioCardListPage translationKey="petsTimeSpent" options={OPTIONS} />
}
